import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import VPNService from './components/VPNService';
import Pricing from './components/Pricing';
import Support from './components/Support';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <VPNService />
      <Pricing />
      <Support />
      <Contact />
      <Footer />
    </div>
  );
}
